import makeStyles from "@material-ui/core/styles/makeStyles";
import Image from "../../../utils/image";

const useStyles = makeStyles((theme) => ({
	logo: {
		display: "flex",
		width: 180
	}
}));

const Logo = ({ children }) => {
	const css = useStyles();
	return (
		<a className={css.logo} href="/">
			<Image
				height="78"
				width="180"
				filename="/img/logo-footer.svg"
				alt="Altenwohnheim Kufstein"
				disableCover
			/>
		</a>
	);
};

export default Logo;
